__turbopack_context__.v({
  "className": "geogrotesque_f55b9d4e-module__dpWT1W__className",
});
